<template>
  <div>
    <div class="font-weight-bold text-uppercase text-center table-outer-title">
      Resumo Financeiro — {{ projeto.nome_projeto }} ({{ projeto.ano_base }})
    </div>
    <div class="table-container">
      <table>
        <tr>
          <th style="width: 25%">RH Direto</th>
          <td style="width: 25%">{{ resumo.rh_direto | toCurrency }}</td>
          <th style="width: 25%">Viagens</th>
          <td style="width: 25%">{{ resumo.viagens | toCurrency }}</td>
        </tr>
        <tr>
          <th>RH Indireto</th>
          <td>{{ resumo.rh_indireto | toCurrency }}</td>
          <th>Equipamentos</th>
          <td>{{ resumo.equipamentos | toCurrency }}</td>
        </tr>
        <tr>
          <th>Softwares</th>
          <td>{{ resumo.softwares | toCurrency }}</td>
          <th>Serviços Terceiros</th>
          <td>{{ resumo.servicos_terceiros | toCurrency }}</td>
        </tr>
        <tr>
          <th>Material de Consumo</th>
          <td>{{ resumo.material_de_consumo | toCurrency }}</td>
          <th>Custo Incorrido</th>
          <td>{{ resumo.custo_incorrido | toCurrency }}</td>
        </tr>
        <tr>
          <th>Outros Correlatos</th>
          <td colspan="3">{{ resumo.outros_correlatos | toCurrency }}</td>
        </tr>
        <tr class="font-weight-bold">
          <th colspan="2">Total Gasto</th>
          <td colspan="2">{{ resumo.total_despesas | toCurrency }}</td>
        </tr>
      </table>
    </div>

    <!-- Antecipações -->
    <div v-if="antecipacoes" class="table-container" style="margin-top: -1px">
      <table>
        <tr>
          <th style="width: 50%">Antecipação do Ano Anterior</th>
          <td style="width: 50%">{{ antecipacoes.valor_antecipado_ano_anterior | toCurrency }}</td>
        </tr>
        <tr>
          <th>Valor Repassado no Ano-Base</th>
          <td>{{ antecipacoes.valor_repassado_ano_base | toCurrency }}</td>
        </tr>
        <tr>
          <th>Antecipação para o Ano Seguinte</th>
          <td>{{ antecipacoes.valor_antecipado_ano_seguinte | toCurrency }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "ResumoFinanceiro",
  props: {
    projeto: {
      type: Object,
      required: true,
    },
    resumo: {
      type: Object,
      required: true,
    },
    antecipacoes: {
      type: Object,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped src="../styles/report.scss"></style>